import cx from "classnames";
import { Icon } from "../components/Icon";
import { LinkWrapper } from "../components/linkWrapper";
import { SanityFigure } from "../components/SanityFigure";
import { MaxWidth } from "../layouts/MaxWidth";
import { PARTNERS } from "../partners";
import styles from "./Reference.module.css";

export type ReferenceProps = {
  lead: string;
  title: string;
  url: string;
  partner?: string;
  text?: string;
  image?: any;
};

export const Reference = ({
  lead,
  title,
  partner,
  text,
  url,
  image,
}: ReferenceProps) => {
  if (partner && PARTNERS[partner]) {
    image = PARTNERS[partner]["logo"];
    text = PARTNERS[partner]["title"];
  }
  if (!url) url = "#";
  const attrs = SanityFigure(image);

  return (
    <div className={cx("reference", styles.reference)}>
      <MaxWidth size="sm">
        <p className={styles.lead}>{lead}</p>
        <LinkWrapper url={url} className={styles.container}>
          {attrs && attrs.src && (
            <img
              src={attrs.src}
              alt={title}
              width={64}
              height={64}
              className={styles.figure}
            />
          )}
          <div className={styles.textContainer}>
            <p className={styles.title}>
              {title}
              <Icon icon="external" className={styles.icon} />
            </p>
            <p className={styles.text}>{text}</p>
          </div>
        </LinkWrapper>
      </MaxWidth>
    </div>
  );
};
